import ChallengeCuration from './ChallengeCuration';

export default ChallengeCuration;
